import { IAppState } from '../../common/state';

export const getMapImage = ({ newbuildingInformation }: IAppState): string | null => {
  return newbuildingInformation?.staticMapUrl || null;
};
